<ion-app>
  @if (loaderSrv.isLoading$ | async) {
    <ion-progress-bar class="progress-loader" type="indeterminate"></ion-progress-bar>
  }
  <app-menu></app-menu>
  <ion-router-outlet id="content"></ion-router-outlet>
  @if (overlay.isVisible() | async) {
    <div class="app-overlay ion-padding" (click)="bioAuthSrv.authenticate()"></div>
  }
</ion-app>
